import {
  useGetAppCtDepartmentsQuery,
  useGetCommanderByTicketIdQuery,
} from '../../services/request-form/construction-site-management.api';

export function GetAppCTDepartments() {
  const {
    data: departments,
    isLoading,
    refetch
  } = useGetAppCtDepartmentsQuery(null, { refetchOnMountOrArgChange: true });

  return {
    departments: departments?.data || [],
    isLoading,
    refetch
  };
}

export function GetDirectCommanders(ticketId: number) {
  const { data: response, isLoading } = useGetCommanderByTicketIdQuery(ticketId!, {
    skip: !ticketId,
    refetchOnMountOrArgChange: true
  });

  return {
    data: response?.data || [],
    isLoading
  };
}

